import React from 'react';
import { FragmentType, graphql, useFragment } from '@frontend/gql/social';
import { CardStat, CardStatLabel, CardStatRow } from '../../../../components/card-stat';
import { MetricChangeIndicator } from '../../../../components/metric-change-indicator';

const ctrFragment = graphql(`
  fragment Ctr_MetaSumInsights on MetaSumInsights {
    totalClicks
    totalImpressions
  }
`);

type CtrProps = {
  currentInterval: FragmentType<typeof ctrFragment> | null | undefined;
  previousInterval: FragmentType<typeof ctrFragment> | null | undefined;
  currentIntervalNotAspireSourced?: FragmentType<typeof ctrFragment> | null | undefined;
  previousIntervalNotAspireSourced?: FragmentType<typeof ctrFragment> | null | undefined;
  showNonAttributedData?: boolean;
};

export const Ctr = ({
  currentInterval,
  previousInterval,
  currentIntervalNotAspireSourced,
  previousIntervalNotAspireSourced,
  showNonAttributedData = false,
}: CtrProps) => {
  const currentIntervalData = useFragment(ctrFragment, currentInterval);
  const previousIntervalData = useFragment(ctrFragment, previousInterval);
  const currentIntervalNotAspireSourcedData = useFragment(ctrFragment, currentIntervalNotAspireSourced);
  const previousIntervalNotAspireSourcedData = useFragment(ctrFragment, previousIntervalNotAspireSourced);

  const currentClicks = currentIntervalData?.totalClicks ?? 0;
  const currentImpressions = currentIntervalData?.totalImpressions ?? 0;
  const previousClicks = previousIntervalData?.totalClicks ?? 0;
  const previousImpressions = previousIntervalData?.totalImpressions ?? 0;

  const currentClicksNotAspire = currentIntervalNotAspireSourcedData?.totalClicks ?? 0;
  const currentImpressionsNotAspire = currentIntervalNotAspireSourcedData?.totalImpressions ?? 0;
  const previousClicksNotAspire = previousIntervalNotAspireSourcedData?.totalClicks ?? 0;
  const previousImpressionsNotAspire = previousIntervalNotAspireSourcedData?.totalImpressions ?? 0;

  const currentCtr = currentImpressions > 0 ? (currentClicks / currentImpressions) * 100 : 0;
  const previousCtr = previousImpressions > 0 ? (previousClicks / previousImpressions) * 100 : 0;
  const currentCtrNotAspire =
    currentImpressionsNotAspire > 0 ? (currentClicksNotAspire / currentImpressionsNotAspire) * 100 : 0;
  const previousCtrNotAspire =
    previousImpressionsNotAspire > 0 ? (previousClicksNotAspire / previousImpressionsNotAspire) * 100 : 0;

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <CardStatRow>
          <CardStat className="text-xl leading-none">{`${currentCtr.toFixed(1)}%`}</CardStat>
          <MetricChangeIndicator current={currentCtr} previous={previousCtr} showTimeRange={false} />
        </CardStatRow>
        <CardStatLabel>Attributed to Aspire</CardStatLabel>
      </div>
      {showNonAttributedData && (
        <div className="space-y-2">
          <CardStatRow>
            <CardStat className="text-xl leading-none">{`${currentCtrNotAspire.toFixed(1)}%`}</CardStat>
            <MetricChangeIndicator
              current={currentCtrNotAspire}
              previous={previousCtrNotAspire}
              showTimeRange={false}
            />
          </CardStatRow>
          <CardStatLabel>Not Attributed to Aspire</CardStatLabel>
        </div>
      )}
    </div>
  );
};
